import React, { useState, useEffect } from "react";

// Importing bootstrap components
import { Form, Button, Table } from "react-bootstrap";

// Importing common components
import HRPagination from "components/HRPagination";

import { useDispatch, useSelector } from "react-redux";

// Importing holiday slices
import { setHolidays } from "state/slices/holiday/holidaySlice";

// Importing holiday mutations
import { useGetHolidaysQuery } from "state/slices/holiday/holidayApiSlice";
import { formatDate } from "utils/date";

const HolidayViewManagement = React.memo(
  ({
    isAllowedToUpdate=false,
    isAllowedToDelete=false,
    handleCheckboxChange = () => {},
    handleEdit = () => {},
    deleteHolidayManage = () => {},
    selectedRow = null,
  }) => {
    const dispatch = useDispatch();

    // Fetch holidays
    const {
      data,
      refetch,
      isLoading: isHolidaysLoading,
    } = useGetHolidaysQuery();

    const holidays = useSelector((state) => state.holiday.holidays);

    useEffect(() => {
      if (data) {
        dispatch(setHolidays(data.holidays));
      }
    }, [data]);

    useEffect(() => {
      refetch();
    }, [holidays]);

    // Pagination states
    const ITEMS_PER_PAGE = 10;
    const totalPages = Math.ceil(holidays.length / ITEMS_PER_PAGE) || 0;
    const [currentPage, setCurrentPage] = useState(1);

    // Calculate the start and end index for the current page
    const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
    const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

    return (
      <>
        <Table striped responsive bordered className="text-center">
          <thead>
            <tr>
              {(isAllowedToUpdate || isAllowedToDelete) && <th></th>}
              <th>S No.</th>
              <th>Holiday</th>
              <th>Date</th>
              {(isAllowedToUpdate || isAllowedToDelete) && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {holidays.length > 0 ? (
              holidays
                .slice(indexOfFirstItem, indexOfLastItem)
                .map((row, index) => (
                  <tr key={row.id} id={row?.isDefault ? "default" : ""}>
                    {(isAllowedToUpdate || isAllowedToDelete) && (
                      <td>
                        <Form.Check
                          type="checkbox"
                          name="row"
                          value={row.id}
                          checked={selectedRow?.id === row.id}
                          onChange={(e) => handleCheckboxChange(e, row)}
                        />
                      </td>
                    )}
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{row.name}</td>
                    <td>{formatDate(row.date, 'dd-MM-yyyy')}</td>
                    {(isAllowedToUpdate || isAllowedToDelete) && (
                      <td>
                        {isAllowedToUpdate && (
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="me-2"
                            disabled={
                              !selectedRow || selectedRow?.id !== row.id
                            }
                            onClick={handleEdit}
                          >
                            <i className="bi bi-pencil-square"></i>
                          </Button>
                        )}
                        {isAllowedToDelete && (
                          <Button
                            size="sm"
                            variant="outline-danger"
                            disabled={
                              !selectedRow || selectedRow?.id !== row.id
                            }
                            onClick={deleteHolidayManage}
                          >
                            <i className="bi bi-trash3"></i>
                          </Button>
                        )}
                      </td>
                    )}
                  </tr>
                ))
            ) : (
              <tr className="bg-light border text-center">
                <td colSpan={6} className="text-muted">
                  {isHolidaysLoading ? "Loading Data..." : "No Data Found"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {/* Pagination */}
        <div className="d-flex justify-content-end">
          <HRPagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </>
    );
  }
);

export default HolidayViewManagement;
